export enum ConnectionStatus {
  Connected = 'connected',
  Disconnected = 'disconnected',
  Syncing = 'syncing',
  PendingReconnect = 'pending_reconnect',
  FailedNotAuthorized = 'failed_not_authorized',
}

export interface UserIntegration {
  id: number;
  provider: string;
  accountId?: string;
  connectionStatus: ConnectionStatus;
}
